// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module__title___2h_PV","party":"styles-module__party___3sZoz"};